// Static data: services, cities, FAQs, testimonials

export const COMPANY = {
  name: "Comfort Care Transportation",
  phone: "571-689-4470",
  phoneRaw: "5716894470",
  email: "info@comfortcarenemt.com",
  address: "4209 Evergreen Lane, Suite #202, Annandale, VA 22003",
  hours: "24/7 Scheduling Support",
  serviceArea: "Virginia, DC & Maryland",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_eb2dcda5-bc04-4ae1-9816-1e732eb67750/artifacts/u7xt03tz_CC-Transport-Logo-2-1920w%20%281%29.webp",
  googleProfileUrl: "https://share.google/3lA4MV1JxIb3TqtLT",
  googleMapsUrl: "https://www.google.com/maps/place/Comfort+Care+Transportation+NEMT/data=!4m2!3m1!1s0x0:0x3c0c10707cc78985?sa=X&ved=1t:2428&hl=en&ictx=111",
  googleReviewUrl: "https://share.google/3lA4MV1JxIb3TqtLT",
};

export const SERVICES = [
  {
    slug: "wheelchair-accessible-transportation",
    title: "Wheelchair Accessible Transportation",
    short: "ADA-compliant vehicles built for safe and dignified wheelchair transport.",
    icon: "Accessibility",
  },
  {
    slug: "non-ambulatory-transportation",
    title: "Non-Ambulatory Transportation",
    short: "Specialized support for passengers who need full mobility assistance.",
    icon: "HeartHandshake",
  },
  {
    slug: "hospital-discharge-transportation",
    title: "Hospital Discharge Transportation",
    short: "Safe, comfortable rides home after surgery or hospital stays.",
    icon: "Hospital",
  },
  {
    slug: "doctor-appointment-transportation",
    title: "Doctor Appointment Transportation",
    short: "On-time rides to primary care, specialists, and medical clinics.",
    icon: "Stethoscope",
  },
  {
    slug: "dialysis-transportation",
    title: "Dialysis Transportation",
    short: "Reliable recurring transportation for dialysis treatment schedules.",
    icon: "Activity",
  },
  {
    slug: "rehabilitation-transportation",
    title: "Rehabilitation Transportation",
    short: "Transport to physical therapy and rehab appointments.",
    icon: "Footprints",
  },
  {
    slug: "assisted-living-transportation",
    title: "Assisted Living Transportation",
    short: "Rides to nursing homes, assisted living, and long-term care facilities.",
    icon: "Home",
  },
  {
    slug: "adult-day-program-transportation",
    title: "Adult Day Program Transportation",
    short: "Daily rides for seniors attending adult day health programs.",
    icon: "Sun",
  },
  {
    slug: "long-distance-medical-transportation",
    title: "Long Distance Medical Transportation",
    short: "Statewide Virginia transport for medical appointments and treatments.",
    icon: "MapPin",
  },
  {
    slug: "customized-transportation-plans",
    title: "Customized Transportation Plans",
    short: "Flexible plans tailored to your unique medical and mobility needs.",
    icon: "Settings2",
  },
];

export const WHY_US = [
  { title: "Compassionate Care", body: "Every passenger is treated with respect, patience, and dignity.", icon: "Heart" },
  { title: "Reliable Scheduling", body: "Dependable pickups and drop-offs you can count on.", icon: "Clock" },
  { title: "Experienced Drivers", body: "Professional transportation specialists focused on safety.", icon: "Award" },
  { title: "Accessible Vehicles", body: "Comfortable, ADA-compliant, properly equipped vehicles.", icon: "Bus" },
  { title: "Family Peace of Mind", body: "Families trust their loved ones are in good hands.", icon: "Users" },
  { title: "Tri-State Coverage", body: "Certified to serve Virginia, Washington DC, and Maryland.", icon: "Map" },
];

export const HOW_IT_WORKS = [
  { step: "01", title: "Request Your Ride", body: "Submit the booking form online or call/text us directly." },
  { step: "02", title: "Review & Confirmation", body: "Our team reviews trip details, confirms pricing, and books your driver." },
  { step: "03", title: "Safe Pickup", body: "A trained driver arrives at your door with the right vehicle for your needs." },
  { step: "04", title: "Comfortable Arrival", body: "Door-to-door, on-time arrival with care every step of the way." },
  { step: "05", title: "Return Transportation", body: "We're ready when you are, with reliable round-trip and recurring options." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Comfort Care has been a blessing for my mother's dialysis appointments. The drivers are kind, patient, and always on time. I finally have peace of mind.",
    name: "Sarah M.",
    location: "Arlington, VA",
    rating: 5,
  },
  {
    quote:
      "After my husband's hip surgery, Comfort Care made his trips to rehab so much easier. The wheelchair van was clean, comfortable, and the team was wonderful.",
    name: "Linda R.",
    location: "Fairfax, VA",
    rating: 5,
  },
  {
    quote:
      "I use a wheelchair full-time and Comfort Care is the only service I trust. Always punctual, always respectful, always safe. Highly recommend.",
    name: "James T.",
    location: "Alexandria, VA",
    rating: 5,
  },
  {
    quote:
      "We needed long-distance transport from Richmond to a specialist in Northern Virginia. The whole process was seamless and stress-free.",
    name: "Patricia L.",
    location: "Richmond, VA",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "What is Non-Emergency Medical Transportation (NEMT)?",
    a: "NEMT provides safe, scheduled transportation for individuals traveling to and from healthcare appointments who do not require an ambulance. We support seniors, wheelchair users, dialysis patients, and anyone needing reliable medical transportation.",
  },
  {
    q: "Do you transport wheelchair users?",
    a: "Yes. All of our vehicles are fully ADA-compliant and equipped with wheelchair lifts and securement systems. Our trained drivers safely load, secure, and transport passengers in standard and power wheelchairs.",
  },
  {
    q: "Do you offer recurring dialysis transportation?",
    a: "Absolutely. Recurring dialysis transportation is one of our core services. We coordinate consistent pickup and drop-off times so your treatment schedule runs smoothly week after week.",
  },
  {
    q: "Do you provide hospital discharge transportation?",
    a: "Yes. We work with patients, families, hospital case managers, and discharge planners to provide safe rides home after surgeries, procedures, and inpatient stays.",
  },
  {
    q: "Do you accept insurance?",
    a: "Comfort Care Transportation is currently a private-pay transportation provider. Upon request, we can provide an itemized invoice or receipt that clients may submit to their insurance company to inquire about possible reimbursement, depending on their plan.",
  },
  {
    q: "How far in advance should I schedule?",
    a: "We recommend booking at least 24-48 hours in advance to guarantee availability. For recurring appointments, we can set up a long-term schedule. Same-day requests may be available based on capacity.",
  },
  {
    q: "What areas do you serve?",
    a: "We are certified to provide non-emergency medical transportation throughout Northern Virginia, Washington DC, and Maryland. Coverage includes Arlington, Alexandria, Fairfax, Annandale, Falls Church, Springfield, Woodbridge, Manassas, Reston, Herndon, Ashburn, Leesburg, McLean, Tysons, Vienna, Burke, and Centreville, the entire District of Columbia, plus the Maryland suburbs (Bethesda, Silver Spring, Rockville, Montgomery & Prince George's counties).",
  },
  {
    q: "Can family members ride along?",
    a: "Yes. One companion or attendant is welcome on most trips at no extra charge. Please let us know in advance so we can plan vehicle space and seating accordingly.",
  },
  {
    q: "Do you offer round-trip transportation?",
    a: "Yes. We offer one-way, round-trip, and recurring transportation. Many of our passengers book round-trips for appointments, treatments, and procedures.",
  },
];

export const CITIES = [
  {
    slug: "annandale",
    name: "Annandale",
    region: "Northern Virginia",
    hospitals: ["Inova Fairfax Hospital", "INOVA Mount Vernon Hospital"],
    blurb: "Our HQ city — premier NEMT service throughout Annandale and surrounding Fairfax County.",
    isHub: true,
  },
  {
    slug: "arlington",
    name: "Arlington",
    region: "Northern Virginia",
    hospitals: ["Virginia Hospital Center", "Arlington Free Clinic"],
    blurb: "Trusted non-emergency medical transportation across Arlington County.",
  },
  {
    slug: "alexandria",
    name: "Alexandria",
    region: "Northern Virginia",
    hospitals: ["Inova Alexandria Hospital", "Kaiser Permanente Alexandria"],
    blurb: "Compassionate NEMT service throughout Alexandria neighborhoods.",
  },
  {
    slug: "fairfax",
    name: "Fairfax",
    region: "Northern Virginia",
    hospitals: ["Inova Fairfax Hospital", "Virginia Hospital Center"],
    blurb: "Wheelchair accessible transportation across Fairfax County.",
  },
  {
    slug: "washington-dc",
    name: "Washington, DC",
    region: "District of Columbia",
    hospitals: ["MedStar Washington Hospital Center", "GWU Hospital", "Howard University Hospital"],
    blurb: "Certified NEMT service throughout the District of Columbia.",
  },
  {
    slug: "bethesda",
    name: "Bethesda",
    region: "Maryland",
    hospitals: ["NIH Clinical Center", "Suburban Hospital", "Walter Reed"],
    blurb: "Wheelchair accessible medical rides across Bethesda, MD.",
  },
  {
    slug: "silver-spring",
    name: "Silver Spring",
    region: "Maryland",
    hospitals: ["Holy Cross Hospital", "Adventist HealthCare White Oak"],
    blurb: "Reliable NEMT service throughout Silver Spring and Montgomery County.",
  },
];

export const ALL_VA_CITIES = [
  // Northern Virginia (our service area)
  "Arlington", "Alexandria", "Fairfax", "Falls Church", "Springfield",
  "Woodbridge", "Manassas", "Chantilly", "Reston", "Herndon",
  "Ashburn", "Leesburg", "McLean", "Tysons", "Vienna",
  "Burke", "Annandale", "Centreville",
  // Washington, DC
  "Washington, DC",
  // Maryland
  "Bethesda", "Silver Spring", "Rockville", "Gaithersburg", "Bowie",
  "College Park", "Hyattsville", "Greenbelt", "Upper Marlboro", "Largo",
];
